import { useEffect } from 'react';
import { Pressable, View, useWindowDimensions } from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';
import usePlatform from '@/utils/hooks/usePlatform';
import Unicon from './Unicon';
import { StyleSheet } from 'react-native-unistyles';

 const BackToTop = ({hidden, viewOffset = 0, ref}) => {
    const { isLandscape } = usePlatform();
    const { width } = useWindowDimensions();

    const move = useSharedValue({
        translate: width,
        rotate: "180deg"
    });
    const buttonStyle = useAnimatedStyle(() => {
        return {
            transform: [
                {translateX: withTiming(move.value.translate, {duration:300})}, 
                {rotate: withTiming(move.value.rotate, {duration:300})}
            ],
        }
    })

    useEffect(() => {
        move.value = {
            translate: hidden ? width : width - 65,
            rotate: hidden ? "180deg" : "0deg"
        }
    }, [hidden])

    return (isLandscape ? null :
        <Animated.View style={[buttonStyle, styles.container]}>
            <View style={styles.button}>
                <Pressable onPress={() => {
                    if (typeof ref.current.scrollTo === "function") { 
                        ref.current.scrollTo({x: 0, y: 0, animated: true})
                    }
                    else{
                        ref.current.scrollToIndex({index:0, viewOffset: viewOffset, animated: true})
                    }
                }} style={styles.pressable}>
                    <Unicon name="chevron-up" size={32} colorVariant="text" />
                </Pressable>
            </View>
        </Animated.View>
    )
}

const styles = StyleSheet.create(({colors, shadows}, rt) => ({
    container:{
        position:"absolute", 
        top:rt.screen.height - 150, 
        zIndex:1000,
    },
    button:{
        width:50, 
        height:50, 
        overflow:"hidden", 
        borderRadius:70, 
        boxShadow: shadows.card,
        backgroundColor:colors.surface
    },
    pressable:{
        alignItems:"center", 
        justifyContent:"center", 
        width:"100%", 
        height:"100%"
    }
}))

export default BackToTop